/** Calls `callback` once, when any part of `element` first comes into view. Returns a function that stops waiting. */
export function whenInView(element: Element, callback: () => void): () => void {
  const observer = new IntersectionObserver((entries) => {
    if (entries.some((entry) => entry.isIntersecting)) {
      observer.disconnect()
      callback()
    }
  })
  observer.observe(element)
  return () => observer.disconnect()
}
